import { useAxiosRequest } from "api/axiosRequest"
import { BASE_URL } from "api/url_helper"
import { useState } from "react"
import { VesselTrackingList } from "./useFetchList"
import axios from "axios"
import { toast } from "react-toastify"

export interface AddList {
  orgId: number | null
  listName: string
  userId: string | null
  listType: "prevet" | "portpredictor" | "user"
}
export function useAddList() {
  const [isAddListLoading, setIsAddListLoading] = useState<boolean>(false)
  const request = useAxiosRequest()
  async function addList(addList: AddList) {
    return request<any, VesselTrackingList>({
      url: `${BASE_URL}/vesseltracking/list/single`,
      method: "POST",
      data: addList,
    })
  }
  const createList = async (
    listAdd: AddList
  ): Promise<VesselTrackingList | undefined> => {
    try {
      setIsAddListLoading(true)
      const res = await addList(listAdd)
      return res?.data
    } catch (err: unknown) {
      const message = "Unable to add vessel tracking list"
      console.error(message, err)
      if (axios.isAxiosError(err)) {
        toast.warn(message, {
          position: "bottom-right",
          autoClose: 8000,
        })
      }
      throw err
    } finally {
      setIsAddListLoading(false)
    }
  }
  return { createList, isAddListLoading }
}
